module.exports = __webpack_public_path__ + "static/media/room-image3.97ab38ca.png";